import { InputTextarea } from "primereact/inputtextarea";
import React from "react";

const GlobalTextArea = ({
  placeholder = "",
  onChange,
  value = "",
  inputType,
  inputId,
  maxLength = 1000,
  invalid,
  inputClassName = "",
  classNameParent,
  keyfilter,
  onKeyDown,
  disabled = false,
  showCounter = true,
  rows = 5,
}) => {
  return (
    <div className={`relative flex flex-col gap-2 ${classNameParent}`}>
      <InputTextarea
        id={inputId}
        autoResize
        rows={rows}
        maxLength={maxLength}
        invalid={invalid}
        placeholder={placeholder}
        keyfilter={keyfilter}
        onKeyDown={onKeyDown}
        type={inputType}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={[
          inputClassName,
          "px-2 p-inputtext-sm w-full py-2.5 text-sm leading-relaxed border border-gray-200 rounded-lg  resize-none outline-none transition-colors focus:ring-1 focus:ring-offset-0",
        ]
          .filter(Boolean)
          .join(" ")}
      />
      {showCounter && (
        <p className="text-end">
          {value.length}/{maxLength}
        </p>
      )}
    </div>
  );
};

export default GlobalTextArea;
